module.exports = __webpack_public_path__ + "public/Icons/15Manageorders.svg?d736dd17";